// 敵タイプ定義
export type EnemyKind = 'slime' | 'goblin' | 'archer' | 'boss';

export interface EnemySpec {
  textureKey: string; // BootScene で読み込んだスプライトシートのキー
  frameWidth: number; // スプライトシートのフレーム幅
  frameHeight: number;
  maxHp: number;
  speed: number; // px/秒
  contactDamage: number; // 接触ダメージ（ハート単位、1=半ハート）
  scale: number;
  // AI関連
  detectRange: number; // 視認範囲（プレイヤー検出）
  attackRange: number; // 攻撃を出せる距離
  isRanged: boolean; // 遠距離攻撃か（弓兵用）
  cooldownMs: number; // 攻撃後の硬直
}

// MVPの難易度バランス：プレイヤーが学習しながら遊べる程度に控えめ
export const ENEMY_SPECS: Record<EnemyKind, EnemySpec> = {
  slime: {
    textureKey: 'enemy_slime',
    frameWidth: 32,
    frameHeight: 32,
    maxHp: 2,
    speed: 28,
    contactDamage: 1,
    scale: 1,
    detectRange: 90,
    attackRange: 22,
    isRanged: false,
    cooldownMs: 800,
  },
  goblin: {
    textureKey: 'enemy_goblin',
    frameWidth: 32,
    frameHeight: 32,
    maxHp: 3,
    speed: 60,
    contactDamage: 1,
    scale: 1,
    detectRange: 140,
    attackRange: 26,
    isRanged: false,
    cooldownMs: 700,
  },
  archer: {
    textureKey: 'enemy_archer',
    frameWidth: 32,
    frameHeight: 32,
    maxHp: 2,
    speed: 40,
    contactDamage: 1,
    scale: 1,
    detectRange: 180,
    attackRange: 150,
    isRanged: true,
    cooldownMs: 2400,
  },
  boss: {
    textureKey: 'enemy_boss',
    frameWidth: 64,
    frameHeight: 64,
    maxHp: 18,
    speed: 45,
    contactDamage: 2,
    scale: 1,
    detectRange: 999,
    attackRange: 50,
    isRanged: false,
    cooldownMs: 1100,
  },
};
